module.exports = __webpack_public_path__ + "static/media/systane.9119c72f.png";